module.exports = __webpack_public_path__ + "img/support_bottom_separate.99b2752f.svg";